export default "__VITE_ASSET__DwktPi$h__"